import "./Invite.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// Firebase auth
import Auth from "../../components/auth/auth";

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End

import { useParams } from "react-router-dom";
import GetAgentData from "../../controllers/agents/GetAgentData";
import updateAgentStatus from "../../controllers/agents/updateAgentStatus";
import useRegister from "../register/scripts/hook";

// Form Validate schema Start
const schema = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password must be greater than 5 characters"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords does not match"),
});
// Form Validate schema End

let agent = null;

const AgentRegistrationForm = () => {
  // Form Validate const Start
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // Form Validate const End

  const dispatch = useDispatch();
  const { linkId } = useParams();

  const [FormDisabled, setFormDisabled] = useState(false);

  const [Name, setName] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [aid, set_aid] = useState("");
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  const [
    AuthState,
    setAuthState,
    RegisterUsingPhoneNumber,
    PhoneFormDisabled,
    RegisterButtonRef,
    CodeSent,
    setCodeSent,
    VerifyCode,
    Error,
    setError,
    ButtonLoader,
    goBack,
    RegisterUsingEmail,
  ] = useRegister();

  useEffect(() => {
    async function fetchData() {
      const [clientId, agentId] = linkId.split("::");
      agent = await GetAgentData(clientId, agentId);
      const { name, email, number, address, is_deleted } = agent;
      setName(name);
      setPhone(number);
      setEmail(email);
      setAddress(address);
      set_aid(agentId);
      setIsDeleted(is_deleted);
    }
    fetchData();
  }, [linkId]);

  const RegisterAgent = async (e) => {
    const a = {
      name: Name,
      email: Email,
      phone: Phone,
      password: e.password,
      business: null,
      aid: aid,
    };
    // return;
    setFormDisabled(true);
    const agentRegistration = await RegisterUsingEmail(a);
    if (agentRegistration !== false) {
      // Update agent status to active
      const [clientId, agentId] = linkId.split("::");
      await updateAgentStatus(clientId, agentId);
      dispatch({
        type: "ADD_NEW_USER",
        payload: agentRegistration,
      });
      window.location.pathname = "/";
      setFormDisabled(true);
    }
    if (agentRegistration === false) {
      setFormDisabled(false);
    } else {
      setFormDisabled(true);
    }
  };

  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  // Password toggle handler
  const toggleConfirmPassword = () => {
    // When the handler is invoked
    // inverse the boolean state of confirmPasswordShown
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  return (
    <>
      <Auth title={"Agent Invitation"}>
        <form onSubmit={handleSubmit(RegisterAgent)}>
          <h2 className="agent-invitation--form-heading">Agent Invitation</h2>
          <div className="form-group Agent-form-group-style">
            <input
              type="text"
              className="form-control input-style"
              placeholder="Name"
              value={Name}
              name="name"
              disabled
            />
          </div>

          <div className="form-group Agent-form-group-style mt-3">
            <input
              type="text"
              className="form-control input-style"
              placeholder="Phone"
              value={Phone}
              name="phone"
              disabled
            />
          </div>

          <div className="form-group Agent-form-group-style mt-3">
            <input
              type="email"
              className="form-control input-style"
              placeholder="Email"
              value={Email}
              name="email"
              disabled
            />
          </div>

          <div className="form-group Agent-form-group-style mt-3">
            <input
              type="email"
              className="form-control input-style"
              placeholder="Address"
              value={Address}
              name="email"
              disabled
            />
          </div>

          <div className="form-group Agent-form-group-style mt-3">
            <span
              onClick={togglePassword}
              className={`agent-pass-icon ${
                passwordShown ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
              } `}
            ></span>
            <input
              type={passwordShown ? "text" : "password"}
              className={`form-control input-style`}
              placeholder="Enter Your Password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              {...register("password")}
              disabled={FormDisabled}
            />
            {errors.password && (
              <p className="errorMessage"> {errors.password?.message} </p>
            )}
          </div>

          <div className="form-group Agent-form-group-style mt-3">
            <span
              onClick={toggleConfirmPassword}
              className={`agent-pass-icon ${
                confirmPasswordShown ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
              } `}
            ></span>
            <input
              type={confirmPasswordShown ? "text" : "password"}
              className={`form-control input-style`}
              placeholder="Confirm Password"
              name="confirmPassword"
              onChange={(e) => setConfirmPassword(e.target.value)}
              {...register("confirmPassword")}
              disabled={FormDisabled}
            />
            {errors.confirmPassword && (
              <p className="errorMessage">{errors.confirmPassword?.message}</p>
            )}
          </div>
          <div className="text-center mt-4">
            {isDeleted === true ? (
              <button
                className="p-0 agent-invitation-account-btn"
                disabled={isDeleted}
              >
                Invite is Deleted
              </button>
            ) : (
              <button
                type="submit"
                className="p-0 agent-invitation-account-btn"
                disabled={FormDisabled}
              >
                {FormDisabled && (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                )}
                Create Account
              </button>
            )}
          </div>
        </form>
      </Auth>
    </>
  );
};

export default AgentRegistrationForm;
